import { useState, useCallback } from 'react';
import { contactsAPI } from '../services/contacts';
import { useApi } from '../../../hooks/api/useApi';

export function useContacts() {
  const [contacts, setContacts] = useState([]);
  const [currentContact, setCurrentContact] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchContacts = useCallback(async (params = {}) => {
    const result = await execute(() => contactsAPI.list(params));
    if (result.success) {
      setContacts(result.data.data?.contacts || []);
    }
    return result;
  }, [execute]);

  const fetchContactById = useCallback(async (contactId) => {
    const result = await execute(() => contactsAPI.getById(contactId));
    if (result.success) {
      setCurrentContact(result.data.data);
    }
    return result;
  }, [execute]);

  const createContact = useCallback(async (data) => {
    const result = await execute(() => contactsAPI.create(data));
    if (result.success) {
      await fetchContacts();
    }
    return result;
  }, [execute, fetchContacts]);

  const updateContact = useCallback(async (contactId, data) => {
    const result = await execute(() => contactsAPI.update(contactId, data));
    if (result.success) {
      setContacts((prev) =>
        prev.map((c) => (c.contact_id === contactId ? { ...c, ...result.data.data } : c))
      );
      if (currentContact?.contact_id === contactId) {
        setCurrentContact(result.data.data);
      }
    }
    return result;
  }, [execute, currentContact]);

  const deleteContact = useCallback(async (contactId) => {
    const result = await execute(() => contactsAPI.delete(contactId));
    if (result.success) {
      setContacts((prev) => prev.filter((c) => c.contact_id !== contactId));
    }
    return result;
  }, [execute]);

  const deactivateContact = useCallback(async (contactId) => {
    const result = await execute(() => contactsAPI.deactivate(contactId));
    if (result.success) {
      setContacts((prev) =>
        prev.map((c) => (c.contact_id === contactId ? { ...c, is_active: false } : c))
      );
    }
    return result;
  }, [execute]);

  return {
    contacts,
    currentContact,
    loading,
    error,
    clearError,
    fetchContacts,
    fetchContactById,
    createContact,
    updateContact,
    deleteContact,
    deactivateContact,
  };
}
